// extracted by mini-css-extract-plugin
export default {"controlBar":"StatsBody_controlBar__egTYH","stats":"StatsBody_stats__uJlun","tabs":"StatsBody_tabs__9vTPl"};